export const defaultPageSizeSystemProvider = 15;
